import { configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { userSlice } from './slices/user-slice';
import { navigationSlice } from './slices/navigation-slice';
import { chatSlice } from './slices/chat-slice';
import onboardingStepsReducer from './slices/onboarding-steps-slice';
import recommendedPromptsReducer from './slices/recommended-prompts-slice';
import agentReducer from './slices/agent-slice';

export const store = configureStore({
  reducer: {
    user: userSlice.reducer,
    navigation: navigationSlice.reducer,
    chat: chatSlice.reducer,
    onboardingSteps: onboardingStepsReducer,
    recommendedPrompts: recommendedPromptsReducer,
    agent: agentReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['user/setUser', 'chat/addMessage', 'chat/updateMessage'],
        // Ignore these field paths in all actions
        ignoredActionPaths: ['payload.timestamp', 'payload.metadata', 'payload.createdAt', 'payload.finishedAt'],
        // Ignore these paths in the state
        ignoredPaths: ['user.user.timestamp', 'chat.messages', 'chat.threads', 'onboardingSteps.steps', 'recommendedPrompts.prompts'],
      },
    }),
  devTools: process.env.NODE_ENV !== 'production',
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Typed hooks for use throughout the app
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
